import { DataBean } from "../DataBean";

export class PayrollTypeList extends DataBean {



    public async getPayrollTypeList(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollTypeList_Number", [id]);
    }

}